<template>
    <section>
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f4 text-bold singleline">{{molang('dpp.saleProceeds.saleProceedsCalc')}}</h2>
                <div class="f7 text-gray singleline" v-show="collapsible.collapsed">Estimated Net Proceeds: {{$filters.formatPrice(netProceeds)}}</div>
            </template>
            <template v-slot:default>
               <mvtSaleProceeds @netProceeds="updateNetProceeds" :salePrice="getAvmValuation || getEstPrice"/>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-saleproceeds.js"></script>

<style lang="scss">
@use './property-saleproceeds.scss' as *;
</style>
